import React from 'react'

const Head = () => {
  return (
    <>

<div className="dr-header">
        <div className="header-contant">
          <h1> Services</h1>
          <p>Doctor {" > "} Headaches And Migraines </p>
        </div>
      </div>

      
      <div className="diabp">
        <h1>Headaches And Migraines</h1>
        <div className="bp-row">
          <div className="bp-col">
            <p>
            We do a comprehensive assessment for headaches and migraines. This includes a thorough history and headache diary. This is followed by a open discussion with parents exploring various therapeutic and preventative options. In older children, botox for headaches is carried out and newer options like Cefaly (nerve stimulating headband) are considered.
            </p>
            
    
           
          </div>
          <div className="bp-col">
            <img src="./img/headache.jpg" alt="" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Head
